<div style="display: flex; justify-content: flex-end; margin-bottom: 12px;">
  <button mat-raised-button color="primary" (click)="add()">
    <mat-icon>add</mat-icon>
    Add Entry
  </button>
  </div>

<mat-card>
  <mat-card-header>
    <mat-card-title>On Now</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-schedule-list (selectedItem)="open($event)" (cancelledChanged)="toggleCancelled($event)" [items]="now"></app-schedule-list>
    <div *ngIf="now.length === 0" style="opacity: 0.7; padding: 8px 0;">No entries currently on.</div>
  </mat-card-content>
</mat-card>

<br>

<mat-card>
  <mat-card-header>
    <mat-card-title>Coming Up</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-schedule-list (selectedItem)="open($event)" (cancelledChanged)="toggleCancelled($event)" [items]="coming"></app-schedule-list>
    <div *ngIf="coming.length === 0" style="opacity: 0.7; padding: 8px 0;">No upcoming entries.</div>
  </mat-card-content>
</mat-card>

<br>

<mat-card>
  <mat-card-header>
    <mat-card-title>Finished</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-schedule-list (selectedItem)="open($event)" (cancelledChanged)="toggleCancelled($event)" [items]="done"></app-schedule-list>
    <div *ngIf="done.length === 0" style="opacity: 0.7; padding: 8px 0;">No finished entries.</div>
  </mat-card-content>
</mat-card>
